/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

"use client";

import { CosmosComponentContextProps, getHero, getSections } from "@cosmos/components";
import { PageHeroesFragment, RefSectionsFragment } from "@cosmos/hygraph-schema";
import { useAuth } from "@cosmos/next-hooks";

import { TemplateProviders } from "./templates/TemplateProviders";

interface BasePageData {
	hero?: PageHeroesFragment | null;
	refSections?: RefSectionsFragment[] | null;
}

interface Props<T> {
	pageData?: T;
	componentContext: CosmosComponentContextProps;
}

export const ClientPageProviders = <T extends BasePageData>({
	pageData,
	componentContext,
}: Props<T>): React.JSX.Element => {
	useAuth(!componentContext.enableAuth);

	return (
		<TemplateProviders componentContext={componentContext}>
			{getHero(pageData?.hero)}
			{getSections(pageData?.refSections)}
		</TemplateProviders>
	);
};
